module.exports = __webpack_public_path__ + "img/move_md.2e32b756.png";